export default "__VITE_PUBLIC_ASSET__60d3379f__"